<sui-dialog-simple>
  <ng-template suiDialogHeader>
    <div class="header">
      @if (objectIcon) {
        <fa-icon [icon]="objectIcon"></fa-icon>
      }
      <h2 ngpDialogTitle>{{ objectTitle }}</h2>
    </div>

    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogContent>
    <div class="cp-infographic">
      <img
        src="assets/illustrations/change-password.png"
        alt="Change password illustration"
      />
    </div>

    @if (formProperties.length > 0) {
      <app-dynamic-form
        #changePasswordForm
        [formProperties]="formProperties"
        [formGroup]="formGroup"
      ></app-dynamic-form>
    }
  </ng-template>

  <ng-template suiDialogFooter>
    <sui-button size="sm" variant="secondary" (click)="cancel()">
      {{ "btn.cancel" | translate }}
    </sui-button>

    <sui-button
      size="sm"
      variant="primary"
      [disabled]="!isValid() || confirmDisabled()"
      [loading]="confirmLoading()"
      (click)="save()"
    >
      {{ "btn.confirm" | translate }}
    </sui-button>
  </ng-template>
</sui-dialog-simple>
